import { render, staticRenderFns } from "./LmBox.vue?vue&type=template&id=17f638fd&scoped=true"
import script from "./LmBox.vue?vue&type=script&lang=js"
export * from "./LmBox.vue?vue&type=script&lang=js"
import style0 from "./LmBox.vue?vue&type=style&index=0&id=17f638fd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17f638fd",
  null
  
)

export default component.exports